import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderRec from '../../header/headerRec';
import CandidatureDetailsCommon from '../../commun/CandidatureDetailsCommon';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';

const DetailsCandid = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const authToken = localStorage.getItem("authToken");

  const [candidature, setCandidature] = useState(null);
  const [editedStatut, setEditedStatut] = useState(null);
  const [messageEntreprise, setMessageEntreprise] = useState('');
  const [dateEntretien, setDateEntretien] = useState('');

  useEffect(() => {
    if (!authToken) return navigate('/');
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await res.json();
        setCandidature(data);
        setEditedStatut(data.statut);
        setMessageEntreprise(data.messageEntreprise || '');
        setDateEntretien(data.dateEntretien || '');
      } catch (error) {
        console.error('Erreur lors du chargement de la candidature', error);
      }
    };
    fetchData();
  }, [id, authToken, API_BASE, navigate]);

  const handleCancel = () => navigate('/recruteur/candidature');

  return (
    <>
      <CandidatureDetailsCommon
        HeaderComponent={HeaderRec}
        headerProps={{
          recruteurName: localStorage.getItem("recruteurName"),
          authToken,
          userId: localStorage.getItem("userId"),
          userRole: "recruteur",
        }}
        candidature={candidature}
        editedStatut={editedStatut}
        setEditedStatut={setEditedStatut}
        messageEntreprise={messageEntreprise}
        setMessageEntreprise={setMessageEntreprise}
        dateEntretien={dateEntretien}
        setDateEntretien={setDateEntretien}
        onCancel={handleCancel}
        API_BASE={API_BASE}
        editable={false}
      />
       <Footer />
      <Chatbox userRole="recruteur" />
    </>
  );
};


export default DetailsCandid;
